import { StandardProps } from "@/types/types";
import styles from "./TotalItems.module.scss";
import { useFeatureFlags } from "@/flags/flags";
import { useRouteParams } from "@/hooks/useRouteParams";

export function TotalItems({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const { results } = productListingData;

  const flags = useFeatureFlags();
  const { query } = useRouteParams();

  if (results <= 1) {
    return null;
  }
  const pageSize = Number(flags.pageSize?.value);

  const activePage = parseInt(
    (Array.isArray(query.page) ? query.page[0] : query.page) || "1",
  );

  const firstProductIndex = (activePage - 1) * pageSize + 1;
  const lastProductIndex = Math.min(activePage * pageSize, results);

  return (
    <div
      data-component="TotalItems"
      className={styles["total-items"]}
      data-testid="total-items"
    >
      {firstProductIndex.toLocaleString("en")}-
      {lastProductIndex.toLocaleString("en")} of {results.toLocaleString("en")}
    </div>
  );
}
